/**
 * @file text.component.tsx
 * @description Простая обертка-прокси для компонента Text из Consta UI Kit, 
 * обеспечивающая единообразное использование текстовых элементов в приложении с сохранением всех оригинальных props.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [@consta/uikit/Text]
 * @related-files []
 */

import { Text as ConstaText } from '@consta/uikit/Text';

export const Text = (props: React.ComponentProps<typeof ConstaText>) => {
    return <ConstaText {...props} />;
};
